import { Component, OnInit, Input, OnDestroy, TemplateRef, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/raksme/services/auth/auth.service';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { WidgetsService } from 'src/raksme/services/widgets/widgets.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'raksme-secbar',
    templateUrl: './raksme.secBarView.html',
    styleUrls: ['./raksme.secBarStyle.css', './raksme.secBarTiers.css'],
    // The bar has to override global theme rules (en-style.css, styles.css) and
    // size the icons inside its child components, so its styles are global and
    // every rule in raksme.secBarStyle.css is scoped under raksme-secbar.
    encapsulation: ViewEncapsulation.None
})
export class SecBarComponent implements OnInit,OnDestroy {
  title = 'rak-sme';

  public subscriptions: Subscription[] = [];

  public userLoginDetails: any = [];

  public toke_exist: boolean = false;

  public lang;
  public arUrl: any = '';
  public headerSocials: any = [];
  public generalLabels: any;
  public header_account: string;
  public header_login: string;

  public SettingsData: any;
  public phoneText: string = '';
  public phoneHref: string = '';

  public socialLoaded: boolean = false;
  public loadGeneral: boolean = false;
  public loadSiteSettings: boolean = false;

  public searchOpen: boolean = false;
  public accountOpen: boolean = false;

  public searchPlaceholder: string = '';

  @Input('generalLabel')
  set setGeneralLabel(_labelData: any){
    this.generalLabels = _labelData;
    this.header_account = _labelData?.header_account;
    this.header_login = _labelData?.header_login_register;
    this.searchPlaceholder = _labelData?.header_search_placeholder;
    this.loadGeneral = true;
  }

  @Input('siteSettings')
  set setSiteSettings(_siteSettings: any){
    this.SettingsData = _siteSettings;
    // website_phone is CMS HTML; the icon-only link needs plain text and a tel: target.
    this.phoneText = String(_siteSettings?.website_phone || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    this.phoneHref = 'tel:' + this.phoneText.replace(/[^+\d]/g, '');
    this.loadSiteSettings = true;
  }

  searchForm: FormGroup;

  public searchVal: string = '';

  public langClass: string = "english-class-raksme";

  resizeObservable$: Observable<Event>
resizeSubscription$: Subscription;

modalRef: BsModalRef;



  constructor(private auth: AuthService, private router: Router, private headerService: WidgetsService, private fb: FormBuilder, private activateRoute: ActivatedRoute, private spinner: NgxSpinnerService, private modalService: BsModalService){}

  ngOnInit(){

    

    
    
    if (this.router.url.includes('/ar') == true){
      this.lang = 'ar';
      this.arUrl = '/ar';
      this.langClass = "arabic-class-raksme";
    }else{
      this.lang = 'en';
    }

    const storage_token = localStorage.getItem('RAKSME_TOKEN');
    if(storage_token) { 
      let item = JSON.parse(storage_token);
      const now = new Date();
      if(now.getTime() > item.expiry){
        
        localStorage.removeItem('RAKSME_TOKEN');
        this.toke_exist = false;
      }else{
        this.toke_exist = true;
        const data = {
          value: item.value,
          expiry: now.getTime() + 1800000
        }
        localStorage.setItem('RAKSME_TOKEN', JSON.stringify(data));
      }
      
    }

    //getsocilas
    this.subscriptions.push(
      this.headerService.getFooterSocials('socials/header').subscribe(
        res => {
          this.headerSocials = res;
          this.socialLoaded = true;
        },
        error => console.log(error)
      )
    );

    //declairing search form

    this.searchForm = this.fb.group({
      search: [this.searchVal, [Validators.required]]
    });

  }


  openLogout(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-md'});
  }

  confirm(): void {
    this.logout();
    this.modalRef.hide();
  }
 
  decline(): void {
    this.modalRef.hide();
  }


  logout(){
    this.spinner.show();
    this.auth.logout();
    this.spinner.hide();
  }


  submittingSearch(){
    
    if(this.searchForm.valid){
      const searchTerm = this.searchForm.value['search'];

      
      this.router.navigate(['/search/'+this.arUrl], { queryParams: { s: searchTerm } });
    }
  }

  ngOnDestroy(){
    this.subscriptions.forEach((sub) => sub.unsubscribe());
     
  }
  
}
